import { Spinner } from '@/components/spinner/'
import { Overlay } from '@/components/overlay/'
import { useAtom } from 'jotai'
import { isLoadingAtom } from '@/store/loading'

export const ScreenLoader = () => {
  const [isLoading] = useAtom(isLoadingAtom)

  if (!isLoading) {
    return
  }

  return (
    <Overlay>
      <Spinner />
    </Overlay>
  )
}
